import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export class HttpHeaderInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const accessToken = localStorage.getItem('access_token');
    if (request.url.match(/token/gi)) {
      const refreshTokenRequest = request.clone({
        setHeaders: {
          Authorization: "Basic " + btoa("android-client:android-secret"),
          "Content-Type": "application/x-www-form-urlencoded",
        }
      });
      return next.handle(refreshTokenRequest);
    }
    // CRM service authenticates via its own X-API-KEY. Don't attach our app's
    // Bearer token to it — it would leak our token to a third-party service and
    // adds an extra custom header to the CORS preflight.
    const isCrmRequest = request.url.includes('/crmservice/');
    if (accessToken && !isCrmRequest) {
      const updateRequest = request.clone({
        setHeaders: {
          'Authorization': 'Bearer ' + accessToken
        }
      });
      return next.handle(updateRequest);
    }
    return next.handle(request);
  }
}
